import { ExpandMore, Sort } from "@mui/icons-material";
import { Box, IconButton, ListItem, ListItemAvatar, ListItemButton } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import React, { useCallback, type MouseEventHandler } from "react";
import { useSearchParams } from "react-router-dom";

const options = ["name", "maxPrice", "rating", /*"released", "sold"*/];

export function SortButton(): JSX.Element {
    const [open, setOpen] = React.useState(false);
    const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
    const [q, setQuery] = useSearchParams();
    const { order, sort, ...query } = Object.fromEntries(q);
    const s = sort ?? "name";
    const handleOrder = useCallback(
        (val: "asc" | "desc") => {
            if (val === "desc") setQuery({ ...query, sort: s, order: val });
            else setQuery({ ...query, sort: s });
        },
        [query, s, setQuery]
    );
    const handleMenuItemClick = useCallback(
        (_: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
            setQuery({ ...query, sort: options[index] });
            setOpen(false);
        },
        [query, setQuery]
    );
    const handleToggle: MouseEventHandler = useCallback((event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setAnchor(event.currentTarget);
        setOpen(prevOpen => !prevOpen);
    }, []);
    const handleClose = useCallback(
        (event: Event) => {
            if (anchor?.contains(event.target as Node)) {
                return;
            }
            setOpen(false);
        },
        [anchor]
    );
    return (
        <React.Fragment>
            <ListItem key="sort" sx={{ padding: "8px 8px" }}>
                <ListItemAvatar sx={{ minWidth: 42 }}>
                    <IconButton sx={{ padding: 0.5 }} size="large" onClick={() => handleOrder(order === "desc" ? "asc" : "desc")}>
                        <Sort sx={order === "desc" ? {} : { transform: "rotate(180deg) scaleX(-1)" }} />
                    </IconButton>
                </ListItemAvatar>
                <ListItemButton onClick={handleToggle} sx={{ textTransform: "capitalize", padding: 0, paddingRight: 1 }}>
                    <Box sx={t => ({ flex: 1, padding: 1, fontSize: "1.1rem", color: t.palette.text.secondary })}>{s}</Box>
                    <ExpandMore color="secondary" />
                </ListItemButton>
            </ListItem>
            <Popper open={open} anchorEl={anchor} transition disablePortal sx={{ zIndex: 1000 }}>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                        }}
                    >
                        <Paper sx={{ paddingTop: "0 !important" }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option}
                                            selected={index === options.findIndex(x => x === s)}
                                            onClick={event => handleMenuItemClick(event, index)}
                                            sx={{ textTransform: "capitalize" }}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    );
}
